import Space from './Space';
export default Space;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-space/src/index.js